import { zodResolver } from '@hookform/resolvers/zod';
import { AllocationRule } from 'further-types/lp/allocations';
import {
  IncomeOrExpenseApportionmentMode,
  IncomeOrExpenseType,
} from 'further-types/lp/income-and-expenses';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { CalendarDay } from 'further-ui/utils';
import { incomeAndExpenses as rules } from 'further-ui/validations';
import { PropsWithChildren } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { z } from 'zod';

const formSchema = rules.CreateIncomeOrExpense;

export type FormValues = z.infer<typeof formSchema>;

type Props = {
  values?: Omit<FormValues, 'apportionmentMode'> & {
    apportionmentMode: IncomeOrExpenseApportionmentMode;
  };
  vehicleId: string;
  baseCurrency?: CurrencyCode;
  defaultCategory?: IncomeOrExpenseType;
};

const FormWrapper: React.FC<PropsWithChildren<Props>> = ({
  children,
  values,
  vehicleId,
  baseCurrency,
  defaultCategory,
}) => {
  const formMethods = useForm<FormValues>({
    shouldFocusError: true,
    resolver: zodResolver(formSchema),
    defaultValues: values ?? {
      vehicleId,
      apportionmentMode: IncomeOrExpenseApportionmentMode.Single,
      startDate: new CalendarDay(new Date()),
      currencyCode: baseCurrency,
      apportionmentPeriods: [],
      category: defaultCategory ?? IncomeOrExpenseType.Income,
      allocationRule: AllocationRule.ByCommitmentAndClosingDate,
    },
    criteriaMode: 'all',
    resetOptions: {
      keepDefaultValues: false,
    },
  });

  return <FormProvider {...formMethods}>{children}</FormProvider>;
};

export default FormWrapper;
